// src/lib/api.ts
import axios from "axios";
// import { toast } from "react-toastify";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000/api",
  timeout: 10000,
});

api.interceptors.request.use((config) => {
  const authUser = localStorage.getItem("authUser");
  const parsedAuthUser = authUser ? JSON.parse(authUser) : null;

  // const token = localStorage.getItem("token");
  // const branch = localStorage.getItem("x-branch");

  const token = parsedAuthUser?.token;
  const branch = localStorage.getItem("branch") || "sharjah";
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (branch) {
    config.headers["x-branch"] = branch;
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    if (response?.data?.message && response.config.method !== "get") {
    }
    return response;
  },
  (error) => {
    const res = error.response;
    const message =
      res?.data?.message ||
      res?.data?.error ||
      (res?.data?.errors ? "errors_array" : null) ||
      "Something went wrong." ;

    // Handle unauthorized session error
    if (message === "Unauthorized: Invalid or expired session") {
      // Clear localStorage
      localStorage.removeItem("authUser");
      localStorage.removeItem("token");
      localStorage.removeItem("branch");
      
      // Redirect to login page
      window.location.href = "/login";
      return Promise.reject(error);
    }

    if (message === "errors_array") {
      const lines = [];
      for (const key in res?.data?.errors) {
        // Ensure the property is directly on the object and not from its prototype chain
        if (Object.prototype.hasOwnProperty.call(res?.data?.errors, key)) {
          lines.push(`${res?.data?.errors[key]}`);
        }
      }
      console.log(lines.join("\n") || "Error");
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default api;
